// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/forgotPassword/forgotPassword.scss
// module id = 127
// module chunks = 0